type DownloadType = {
  fill: string
  width: string
  height: string
  title: string
  className?: string
}

function Download(props: DownloadType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'upload'
  const className = props.className || ''

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      className='w-m h-m sm:w-l sm:h-l'
    >
      <title>{title}</title>
      <g fill={fill} strokeLinecap='butt' strokeLinejoin='miter'>
        <line
          fill='none'
          stroke={fill}
          strokeMiterlimit='10'
          strokeWidth='2'
          x1='24'
          x2='24'
          y1='4'
          y2='33'
          className={className}
        />
        <polyline
          fill='none'
          points='14 23 24 33 34 23'
          stroke={fill}
          strokeLinecap='square'
          strokeMiterlimit='10'
          strokeWidth='2'
          className={className}
        />
        <path
          d='M4,32v8a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V32'
          fill='none'
          stroke={fill}
          strokeLinecap='square'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </g>
    </svg>
  )
}

export default Download
